export default function logger() {
  console.error('LOG --- ', ...arguments)
}
